import React from 'react';
import { 
  CheckCircle, 
  Block, 
  Cancel, 
  Schedule, 
  Assignment, 
  Info,
  Warning,
  Error as ErrorIcon
} from '@mui/icons-material';

/**
 * Retorna a cor correspondente ao status do contrato ou serviço para uso em Chips do MUI
 */
export const getStatusColor = (status: string): "success" | "warning" | "error" | "info" | "default" | "primary" | "secondary" => {
  switch (status) {
    case 'ativo':
      return 'success';
    case 'bloqueado':
      return 'warning';
    case 'cancelado':
      return 'error';
    case 'suspenso':
      return 'warning'; // Alterado para warning para consistência
    case 'inadimplente':
      return 'error';
    case 'aguardando_instalacao':
    case 'aguardando_assinatura':
      return 'info';
    case 'inativo':
      return 'default';
    default:
      return 'default';
  }
};

/**
 * Retorna o rótulo amigável para o status
 */
export const getStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    ativo: 'Ativo',
    bloqueado: 'Bloqueado',
    cancelado: 'Cancelado',
    suspenso: 'SUSPENSO',
    inadimplente: 'Inadimplente',
    aguardando_instalacao: 'Aguardando Instalação',
    aguardando_assinatura: 'Aguardando Assinatura',
    inativo: 'Inativo',
  };
  return labels[status?.toLowerCase()] || status;
};

/**
 * Retorna o ícone correspondente ao status
 */
export const getStatusIcon = (status: string, fontSize: 'small' | 'inherit' | 'medium' | 'large' = 'small') => {
  switch (status) {
    case 'ativo':
      return <CheckCircle fontSize={fontSize} color="success" />;
    case 'bloqueado':
      return <Block fontSize={fontSize} color="warning" />;
    case 'cancelado':
      return <Cancel fontSize={fontSize} color="error" />;
    case 'suspenso':
      return <Block fontSize={fontSize} color="warning" />;
    case 'inadimplente':
      return <ErrorIcon fontSize={fontSize} color="error" />;
    case 'aguardando_instalacao':
    case 'aguardando_assinatura':
      return <Schedule fontSize={fontSize} color="info" />;
    case 'inativo':
      return <Info fontSize={fontSize} color="disabled" />;
    default:
      return <Info fontSize={fontSize} />;
  }
};
